// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Condition_wrapper__2q1KI"};